<div id="app-wrapper">
  @if (universalService.userLoggedIn && !universalService.hideLeftMenu && !router.url.includes('/webview')) {
    @if(universalService.isMobileDevice) {
      <lib-left-menu/>
    }@else{
      @if(universalService.iframeLogin){
        <lib-left-menu/>
      }@else{
        @if(universalService.leftMenu){
          <common-new-left-menu/>
        }
      }
    }
  }
</div>